(function ($) {
    let $fn = $(".comp_slider_gallery");

    if ($fn.length) {
        fn_render_gallery_slider($fn);
    }
})(jQuery);